module.exports = __webpack_public_path__ + "img/peru-flag.24af02d6.png";